import React from "react";
import { withRouter } from "react-router-dom";
import { Urls } from "../Urls";

/**
 * ErrorBoundary component that catches JavaScript errors in its child component tree.
 *
 * @component
 * @returns {React.ReactNode} The ErrorBoundary component or its children.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  /**
   * Lifecycle method that catches JavaScript errors anywhere in the child component tree.
   *
   * @param {Error} error - The error that was thrown.
   * @param {object} info - An object with information about the component stack.
   */
  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  handleBackToHome = () => {
    this.props.history.push("/");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="d-flex flex-column justify-content-center align-items-center pb-5"
          style={{ height: "100vh" }}
        >
          <img
            src={Urls.LorriLogoLogin}
            alt="Logo"
            className="img-fluid mb-2"
            style={{ maxHeight: "100px" }}
          />
          <h1>Something went wrong.</h1>
          <div className="text-center pt-1">
            <div className="text-secondary font-italic pb-2">
              We have sent an incident report to our tech support.
            </div>
            <p className="text-secondary font-italic">
              Please contact{" "}
              <a href="mailto:connect@logisticsnow.in">
                connect@logisticsnow.in
              </a>{" "}
              for any assistance.
            </p>
          </div>
          <div>
            <button
              className="btn btn-link btn-sm"
              onClick={() => window.location.assign("/")}
            >
              Back to Home
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
